import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import Swal from 'sweetalert2';
import toast, { Toaster } from 'react-hot-toast';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Box, Button, Tabs, Tab, Paper, Typography, Grid, Card, Chip, CardContent, Divider, FormControl } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Backdrop } from "@mui/material";
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import environment from '../../environment/environment';
import Repayment from '../Repayment/Repayment';
import Sidebar from '../../components/Sidebar/Sidebar';
import CustomSpinner from '../../components/CustomeSpinner/CustomeSpinner';

const History = ({ data }) => {
    const [historyDetails, setHistoryDetails] = useState([]);
    const [expanded, setExpanded] = useState('');
    const [email, setEmail] = useState('');
    const [orderStatus, setOrderStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [repaymentDetails, setRepaymentDetails] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        let token = localStorage.getItem('accessToken');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                if (decoded && decoded.email) {
                    setEmail(decoded.email);
                } else {
                    console.warn("Email not found in token");
                }
            } catch (error) {
                console.error("Invalid token:", error);
            }
        } else {
            console.warn("No token found in localStorage");
        }
    }, []);
    useEffect(() => {
        getAllOrderByMail();
    }, [email]);

    const getAllOrderByMail = () => {
        setIsLoading(true);
        if (email) {
            axios({
                url: `${environment.config.apiOrderUrl}order/getOrderByEmail?email=${email}`,
                method: "GET",
                headers: {
                    authorization: "your token comes here",
                },
            })
                .then((res) => {
                    if (res && res.data) {
                        setHistoryDetails(res.data);
                        setOrderStatus(res.data.orderStatus);
                        setTimeout(() => {
                            setIsLoading(false);
                        }, 1500);
                    }
                })
                .catch((err) => {
                    toast.error('Something went wrong.Please try again later!');
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1500);
                })
                .finally(()=>{
                    setIsLoading(false);
                })
        }
    }

    const handleChange = (panel, item) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : null);
        setRepaymentDetails(isExpanded ? item : null);
    };

    const handleCancelOrder = async (item) => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-danger"
            },
            buttonsStyling: false
        });

        const result = await swalWithBootstrapButtons.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            input: "textarea",
            inputPlaceholder: "Enter a note before cancelling order",
            inputValidator: (value) => {
                if (!value) {
                    return "Please enter a note before cancelling order!";
                }
            },
            showCancelButton: true,
            confirmButtonText: "Yes, cancel it!",
            cancelButtonText: "No!",
            reverseButtons: true,
            preConfirm: (note) => {
                return new Promise((resolve) => {
                    if (note) {
                        resolve(note);
                    }
                });
            },
            didOpen: () => {
                const actions = document.querySelector('.swal2-actions');
                if (actions) {
                    actions.style.display = 'flex';
                    actions.style.gap = '10px';
                }
            }
        });

        if (result.isConfirmed) {
            const requestBody = { noteInfo: result.value };
            try {
                setIsLoading(true);
                const response = await axios.post(
                    `${environment.config.apiOrderUrl}noteDetails/cancleOrderwithNote/${item.orderId}`,
                    requestBody
                );
                if (response.status === 200) {
                    toast.success("Your order cancellation request sent to admin!");
                    swalWithBootstrapButtons.fire({
                        title: "Order cancelled successfully!",
                        icon: "success"
                    });
                    getAllOrderByMail();
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1500);
                } else {
                    toast.error("Something went wrong. Please try again.");
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1500);
                }
            } catch (error) {
                toast.error("Failed to cancel order. Please try again later.");
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);
            }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            swalWithBootstrapButtons.fire({
                title: "Cancelled",
                icon: "error"
            });
        }
    };

    return (
        <>
            <div style={{ backgroundColor: '#EBEDF2' }}>
                <Header />
                <Sidebar className='sidebartoggle' />
                {isLoading &&
                    <Backdrop
                        sx={{
                            color: "#fff",
                            zIndex: (theme) => theme.zIndex.drawer + 1,
                            backdropFilter: "blur(5px)",
                            backgroundColor: "rgba(0, 0, 0, 0.4)"
                        }}
                        open={isLoading}
                    >
                        <CustomSpinner color="inherit" />
                    </Backdrop>
                }
                <Toaster
                    position="top-right"
                    reverseOrder={false}
                />
                <div className='container mb-5'>
                    <div className='card mt-5'>
                        <div className='card-header d-flex justify-content-between align-items-center'>
                            <div style={{ fontSize: '20px', fontWeight: '600' }}>History</div>
                        </div>
                        <div className='card-body'>
                            {historyDetails && historyDetails.orderDetailsList?.length > 0 ? (
                                historyDetails.orderDetailsList?.map((item, index) => (
                                    <Accordion
                                        className="itineraryaccordion mt-3"
                                        key={index}
                                        expanded={expanded === index}
                                        onChange={handleChange(index, item)}
                                        sx={{
                                            marginBottom: 2, '&::before': {
                                                backgroundColor: 'transparent!important',
                                                boxShadow: 'none ',
                                                borderRadius: 3,
                                            }
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls={`panel${item.id}-content`}
                                            id={`panel${item.id}-header`}
                                            sx={{
                                                backgroundColor: '#fffbdf',
                                                borderRadius: '12px',
                                                minHeight: { xs: 64, sm: 72 },
                                                '&.Mui-expanded': {
                                                    borderBottomLeftRadius: 0,
                                                    borderBottomRightRadius: 0,
                                                },
                                                px: { xs: 2, sm: 3 },
                                                py: 1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                    gap: { xs: 1.5, sm: 2 },
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <Typography
                                                    component="span"
                                                    sx={{
                                                        fontWeight: 700,
                                                        backgroundColor: '#fff099',
                                                        color: '#2d2b29',
                                                        borderRadius: '10px',
                                                        px: { xs: 1.5, sm: 2 },
                                                        py: 1,
                                                        minWidth: { xs: '32px', sm: '40px', md: '50px' },
                                                        height: { xs: '32px', sm: '40px' },
                                                        textAlign: 'center',
                                                        fontSize: { xs: '0.875rem', sm: '1rem' },
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    {index + 1}
                                                </Typography>
                                                <Typography
                                                    component="div"
                                                    sx={{
                                                        fontSize: { xs: '0.875rem', sm: '1rem' },
                                                        fontWeight: 600,
                                                        flex: 1,
                                                        minWidth: 0,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        display: '-webkit-box',
                                                        WebkitLineClamp: { xs: 2, sm: 1 },
                                                        WebkitBoxOrient: 'vertical',
                                                        lineHeight: 1.3,
                                                        mr: 1
                                                    }}
                                                >
                                                    {item.packageName}
                                                </Typography>
                                                <Box sx={{ flexShrink: 0 }}>
                                                    {/* <Chip
                                                        label={ */}
                                                    <Box sx={{
                                                        display: 'flex', alignItems: 'center', gap: 0.5,
                                                        color:
                                                            item.orderStatus === 'Accepted'
                                                                ? 'green'
                                                                : item.orderStatus === 'Inprogress'
                                                                    ? 'orange'
                                                                    : item.orderStatus === 'Cancel'
                                                                        ? 'red'
                                                                        : 'inherit'

                                                    }}>
                                                        <Typography
                                                            component="span"
                                                            sx={{
                                                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                                                fontWeight: 600
                                                            }}
                                                        >
                                                            {item.orderStatus === 'Accepted' ? 'Completed' : item.orderStatus}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </AccordionSummary>
                                        <AccordionDetails className="accordion-details d-flex flex-column">
                                            <div className='container'>
                                                <div className='canclebtn'>
                                                    <Grid xs={12} md={12} sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'row' }, justifyContent: 'flex-end', gap: { xs: '10px', md: '10px' }, }}>
                                                        {item.orderStatus === 'Cancel' ? ('') : (
                                                            <Grid>
                                                                <Button variant="contained" style={{ backgroundColor: '#1972d2', color: 'white', textTransform: 'capitalize' }} onClick={() => handleCancelOrder(item)}>
                                                                    Cancel order
                                                                </Button>
                                                            </Grid>
                                                        )}
                                                        {item.orderStatus === 'Inprogress' && expanded === index && repaymentDetails && (
                                                            <Grid sx={{ height: { xs: '20px', md: 'auto' } }}>
                                                                <Repayment repaymentDetails={repaymentDetails} />
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </div>
                                                <div className='d-flex flex-row mt-2'>
                                                    <div className='col-md-6 col-6'>
                                                        <Typography
                                                            component="span"
                                                            sx={{
                                                                fontSize: '13px',
                                                                fontWeight: 600,
                                                                flex: 1,
                                                                display: 'flex',
                                                                justifyContent: 'start',
                                                                alignItems: 'center',
                                                                marginTop: 2,
                                                                marginBottom: '15px'
                                                            }}
                                                        >
                                                            Package Details : -
                                                        </Typography>
                                                        <ul style={{ fontSize: '13px', listStyle: 'none', padding: 0, lineHeight: 2, marginLeft: 0 }}>
                                                            <li className="row mb-2">
                                                                <div className="col-md-3">Departure City</div>
                                                                <div className="col-md-8">
                                                                    <strong>{item.departureCity}</strong>
                                                                </div>
                                                            </li>
                                                            <li className="row mb-2">
                                                                <div className="col-md-3">Departure Date</div>
                                                                <div className="col-md-8">
                                                                    <strong>
                                                                        {item.departureDate} &nbsp; - &nbsp;
                                                                        {new Date(item.departureDate).setDate(
                                                                            new Date(item.departureDate).getDate() + (parseInt(item.packageDays || 0) - 1)
                                                                        ) &&
                                                                            new Date(
                                                                                new Date(item.departureDate).setDate(
                                                                                    new Date(item.departureDate).getDate() + (parseInt(item.packageDays || 0) - 1)
                                                                                )
                                                                            ).toLocaleDateString("en-GB", {
                                                                                day: "2-digit",
                                                                                month: "short",
                                                                                year: "numeric",
                                                                            })}
                                                                    </strong>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>Total Travellers</div>
                                                    {Array.isArray(item.travellerDetailsList[0]?.adultDetails) &&
                                                        item.travellerDetailsList[0].adultDetails.length > 0 ? (() => {
                                                            const hasAadhar = item.travellerDetailsList[0]?.adultDetails?.some((a) => a?.aadharNo);
                                                            const totalColumns = hasAadhar ? 5 : 4;
                                                            const totalTravellers = (item.travellerDetailsList[0]?.adultDetails.length) + (item.travellerDetailsList[0]?.childDOB.length);
                                                            return (
                                                                <div className="table table-responsive mt-3">
                                                                    <table className="table table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Sr.No.</th>
                                                                                <th>Full Name</th>
                                                                                {hasAadhar && <th>Aadhar No</th>}
                                                                                <th>Mobile No.</th>
                                                                                <th>Price<br />(Per Person)</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td colSpan={totalColumns}><strong>Adults</strong></td>
                                                                            </tr>
                                                                            {item.travellerDetailsList[0].adultDetails.map((adult, index) => (
                                                                                <tr key={`adult-${index}`}>
                                                                                    <td>{index + 1}</td>
                                                                                    <td>{adult.firstName} {adult.lastName}</td>
                                                                                    {hasAadhar && <td>{adult.aadharNo || "-"}</td>}
                                                                                    <td>{adult.mobileNo}</td>
                                                                                    <td>{adult.price}</td>
                                                                                </tr>
                                                                            ))}
                                                                            {Array.isArray(item.travellerDetailsList[0]?.childDOB) &&
                                                                                item.travellerDetailsList[0].childDOB.length > 0 && (
                                                                                    <>
                                                                                        <tr>
                                                                                            <td colSpan={totalColumns}><strong>Childs</strong></td>
                                                                                        </tr>
                                                                                        {item.travellerDetailsList[0].childDOB.map((child, childIndex) => (
                                                                                            <tr key={`child-${childIndex}`}>
                                                                                                <td>{item.travellerDetailsList[0].adultDetails.length + childIndex + 1}</td>
                                                                                                <td>{child.firstName} {child.lastName}</td>
                                                                                                {hasAadhar && <td>{child.aadharNo || "-"}</td>}
                                                                                                <td>{child.mobileNo || "-"}</td>
                                                                                                <td>{child.price}</td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </>
                                                                                )}
                                                                            <tr>
                                                                                <td colSpan={totalColumns - 1}><strong>Sub Total</strong></td>
                                                                                <td>
                                                                                    <strong>
                                                                                        ₹{(
                                                                                            item.travellerDetailsList[0]?.adultDetails?.reduce((acc, curr) => acc + Number(curr.price || 0), 0) +
                                                                                            item.travellerDetailsList[0]?.childDOB?.reduce((acc, curr) => acc + Number(curr.price || 0), 0)
                                                                                        ).toFixed(2)}
                                                                                    </strong>
                                                                                </td>
                                                                            </tr>
                                                                            {item.acPrice &&
                                                                                <tr>
                                                                                    <td colSpan={totalColumns - 1}><strong>AC Price (₹{item.acPrice} x {totalTravellers} persons)</strong></td>
                                                                                    <td><strong>₹{Number(item.acPrice * totalTravellers).toFixed(2)}</strong></td>
                                                                                </tr>
                                                                            }
                                                                            <tr>
                                                                                <td colSpan={totalColumns - 1}><strong>GST Amount (5%)</strong></td>
                                                                                <td><strong>₹{(item.grandTotal - item.grandTotal / 1.05).toFixed(2)}</strong></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colSpan={totalColumns - 1}><strong>Total Amount</strong></td>
                                                                                <td><strong>₹{(item.grandTotal).toFixed(2)}</strong></td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colSpan={totalColumns - 1}>
                                                                                    <strong>{item.previousPaidAmount > 0 ? "Current Paid Amount" : "Paid Amount"}</strong>
                                                                                </td>
                                                                                <td><strong>₹{Number(item.paidAmount).toFixed(2)}</strong></td>
                                                                            </tr>
                                                                            {item.previousPaidAmount > 0 && (
                                                                                <tr>
                                                                                    <td colSpan={totalColumns - 1}><strong>Previous Paid Amount</strong></td>
                                                                                    <td><strong>₹{Number(item.previousPaidAmount).toFixed(2)}</strong></td>
                                                                                </tr>
                                                                            )}
                                                                            {item.pendingAmount > 0 && (
                                                                                <tr>
                                                                                    <td colSpan={totalColumns - 1}><strong>Pending Amount</strong></td>
                                                                                    <td><strong>₹{Number(item.pendingAmount || 0).toFixed(2)}</strong></td>
                                                                                </tr>
                                                                            )}
                                                                            
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            );
                                                        })() : null}
                                                </div>
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                ))
                            ) : (
                                <Typography
                                    component="span"
                                    sx={{
                                        fontSize: { sm: '12px', sm: '13px' },
                                        fontWeight: 600,
                                        flex: 1,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginTop: 2,
                                    }}
                                >
                                    No history available...
                                </Typography>
                            )}
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default History
